import React from "react";
import { Text } from "react-internationalization";
import {
  NEBRASKA_CONSTS,
  ILS_CONSTS,
  VERDA_CONSTS,
} from "../../Utils/StaticData/Constant";
export const LANG = {
  PLAN: {
    IN1E: "GRAN VENTAJA DIRECTA TARJETA DORADA (OSS)",
    IN1F: "GRAN VENTAJA DIRECTA TARJETA DORADA (OSS) DENTAL",
    IN2D: "GRAN VENTAJA DIRECTA TARJETA PLATINO (OSS)",
    SH04: "GRAN VENTAJA DIRECTA BÁSICO (OSS)",
    SH05: "GRAN VENTAJA DIRECTA PRIMA (OSS)",
    SH1B: "GRAN VENTAJA DIRECTA DENTAL BÁSICA (OSS)",
    SH2C: "GRAN VENTAJA DIRECTA PREMIUM (OSS) DENTAL",
    ME03: "GRAN VENTAJA DIRECTA (OSS)",
  },
  CATEGORY: {
    //INDIVIDUAL: "Individual",
    INDIVIDUAL: "Planes individuales Medicare Advantage",
    //GROUP: "Grupo",
    GROUP:
      "Antiguos planes de Medicare grupal para jubilados de Sharp HealthCare",
    // RETIREE: "Jubilada",
    RETIREE:
      "Plan de Medicare grupal para ex jubilados de la ciudad de San Diego (SDPEBA)",
  },
  SORTBY: {
    en: {
      SORTBY: "Sort by",
      PHTL: "Premium: High to Low",
      PLTH: "Premium: Low to High",
      PCPHTL: "PCP Copay: High to Low",
      PCPLTH: "PCP Copay: Low to High",
      SHTL: "Specialist Copay: High to Low",
      SLTH: "Specialist Copay: Low to High",
    },
    es: {
      SORTBY: "Ordenar por",
      PHTL: "Prima: Alto a bajo",
      PLTH: "Prima: Bajo a alto",
      PCPHTL: "Copago de PCP: Alto a bajo",
      PCPLTH: "Copago de PCP: Bajo a alto",
      SHTL: "Copago especialista: Alto a bajo",
      SLTH: "Copago especialista: Bajo a alto",
    },
  },
  INCLUDED_BENEFITS: {
    Dental: "Dental",
    "Routine eye exam (every 12 months)":
      "Examen de la vista de rutina (cada 12 meses)",
    "Hearing aids": "Audífonos",
    "Silver&Fit® Fitness Benefit":
      "Beneficio de acondicionamiento físico Plata&Fit®",
    "Chiropractic care": "Atención quiropráctica",
    Acupuncture: "Acupuntura",
    "Over-the-counter (OTC) items": "Artículos de venta libre (OTC)",
    "Silver&Fit®": "Plata&Fit®",
    "Dental premium": "Prima dental",
  },
  PLAN_DETAILS: {
    HEADINGS: {
      "Plan overview": "Descripción general del plan",
      "Supplemental benefits": "Beneficios suplementarios",
      "Doctor visits": "Visitas al médico",
      "Hospital visits and emergencies": "Visitas hospitalarias y urgencias.",
      "Medicare Part D drugs: initial coverage":
        "Medicamentos de la Parte D de Medicare: cobertura inicial",
      "Prescription Drugs": "Medicamentos con receta",
    },
    SUB_HEADINGS: {
      "Retail: 1-month supply": "Minorista: suministro para 1 mes",
      "Mail order: 3-month supply":
        "Pedido por correo: suministro para 3 meses",
      "30-day retail prescription drugs":
        "Medicamentos recetados al por menor para 30 días",
      "90-day mail prescription drugs":
        "Medicamentos recetados por correo para 90 días",
      "Retail: 30-day supply": "Venta al por menor: suministro para 30 días",
      "Mail order: 100-day supply":
        "Pedido por correo: suministro para 100 días",
      "100-day mail prescription drugs":
        "Medicamentos recetados por correo para 100 días",
    },
    DETAILS_KEYS: {
      "Monthly plan premium": "Prima del plan mensual",
      "Monthly medical plan premium": "Prima mensual del plan médico",
      "Monthly dental plan premium": "Prima mensual del plan dental",
      Deductible: "Deducible",
      "Annual out-of-pocket maximum": "Desembolso máximo anual",
      Dental: "Dental",
      "Dental premium": "Prima dental",
      "Routine eye exam (every 12 months)":
        "Examen de la vista de rutina (cada 12 meses)",
      "Hearing aids": "Audífonos",
      "Silver&Fit®": "Plata&Fit®",
      "Silver&Fit® Fitness Benefit":
        "Beneficio de acondicionamiento físico Silver&Fit®",
      "Chiropractic care": "Atención quiropráctica",
      Acupuncture: "Acupuntura",
      "Over-the-counter (OTC) items": "Artículos de venta libre (OTC)",
      "Primary care physician visit": "Visita al médico de atención primaria",
      "Specialist visit": "Visita de especialista",
      "Preventive care": "Cuidado preventivo",
      "Lab services / X-rays": "Servicios de laboratorio / Rayos X",
      "Diagnostic radiology (e.g., MRIs)":
        "Radiología de diagnóstico (p. ej., resonancias magnéticas)",
      "Inpatient hospital coverage":
        "Cobertura hospitalaria para pacientes internados",
      "Outpatient hospital coverage":
        "Cobertura hospitalaria para pacientes ambulatorios",
      "Emergency care": "Cuidados de emergencia",
      "Urgently needed services": "Servicios que se necesitan con urgencia",
      "Tier 1 (Preferred Generic)": "Nivel 1 (genérico preferido)",
      "Nivel 2 (genérico)": "Nivel 2 (genérico)",
      "Tier 3 (Preferred Brand)": "Nivel 3 (marca preferida)",
      "Tier 4 (Non-preferred Brand)": "Nivel 4 (Marca no preferida)",
      "Tier 5 (Specialty)": "Nivel 5 (especialidad)",
      "Tier 6 (Select Care)": "Nivel 6 (atención selecta)",
      "Tier 2 (Generic)": "Nivel 2 (genérico)",
      "Emergency room (waived if admitted to hospital)":
        "Sala de emergencias (no se aplica si es ingresado en el hospital)",
      Hospitalization: "Hospitalización",
      "Outpatient surgery": "Cirugía ambulatoria",
      "$2,900 yearly limit for services you receive from in-network providers":
        "Límite anual de $2,900 para los servicios que recibe de proveedores dentro de la red",
      "$3,000 allowance every 36 months": "Asignación de $3,000 cada 36 meses",
      "$10, limit 30 visits per year (combined)":
        "$10, límite de 30 visitas por año (combinadas)",
      "Up to $100 per quarter": "Hasta $100 por trimestre",
      "Up to $125 per quarter": "Hasta $125 por trimestre",
      "15% of the cost": "15% del costo",
      "$225/day for days 1-7 $0/day for days 8 +":
        "$225/día para los días 1-7 $0/día para los días 8+",
      "$150/day for days 1-8. $0/day for days 9 +":
        "$150/día para los días 1-8. $0/día por los días 9 +",
      "$150/day for days 1-8. $0/day for days 9 +":
        "$150/día para los días 1-8. $0/día por los días 9 +",
      "$30 ($90 for worldwide urgent care and emergency coverage)":
        "$30 ($90 para atención de urgencia y cobertura de emergencia en todo el mundo)",
      "33% of the cost": "33% del costo",
      "Not offered": "No ofrecido",
      "$13 monthly premium": "prima mensual de $13",
      "$1,000 allowance every 36 months": "Asignación de $1,000 cada 36 meses",
      "$10, limit 30 visits per year": "$10, límite de 30 visitas por año",
      "$90 / 33% of the cost": "$90 / 33% del costo",
      "$180 / Not offered": "$180 / No ofrecido",
      "$125/day for days 1 through 5. $0/day for days 6 and beyond.":
        "$125/día para los días 1 al 5. $0/día para los días 6 y posteriores.",
      "$50/day for days 1 through 6. $0/day for days 7 and beyond.":
        "$50/día para los días 1 al 6. $0/día para los días 7 y posteriores.",
      "$3,500 allowance every 36 months": "Asignación de $3,500 cada 36 meses",
      "25% of the cost / $0": "25% del costo / $0",
      "Not offered / $0": "No ofrecido / $0",
      "$0/day": "$0/día",
      "Part B Premium": "Prima de la Parte B",
      "Part A: $1,600 Part B: $226*": "Parte A: $1,600 Parte B: $226*",
      "Part A: $1,600  Part B: $226*": "Parte A: $1,600 Parte B: $226*",
      "No Limit": "Sin límite",
      "Limited Coverage": "Cobertura limitada",
      "Exams to diagnose and treat diseases and conditions of the eye (including yearly glaucoma screening): 20% coinsurance":
        "Exámenes para diagnosticar y tratar enfermedades y afecciones de la vista (incluida la prueba de detección de glaucoma anual): 20 % de coseguro",
      "Not Covered": "No cubierta",
      "Limited Services, manipulation of the spine to correct and subluxation":
        "Servicios limitados, manipulación de la columna para corregir y subluxación.",
      "20% coinsurance": "20% de coseguro",
      "Not Applicable": "No aplica",
      "Up to 90 - 150 days covered $0 after deductible per day for days 1 - 60 $400 per day for days 61 - 90 $800 per day for days 91 - beyond(up to 60 days over your lifetime)":
        "Hasta 90 - 150 días cubiertos $0 después del deducible por día para los días 1 - 60 $400 por día para los días 61 - 90 $800 por día para los días 91 - posteriores (hasta 60 días durante su vida)",
      "20% coinsurance - Waived if admitted to the hospital within 3 days":
        "20 % de coseguro: exento si ingresa en el hospital dentro de los 3 días",
      "Non-Preferred / Specialty": "No preferida / Especialidad",
      "Preferred Brand": "Marca preferida",
      "Preferred Generic / Generic": "Genérica preferida / Genérica",
      "Select Care": "Seleccione Cuidado",
      "Preferred Brand / Non-Preferred": "Marca preferida/no preferida",
      "Specialty / Select Care": "Atención especializada/selecta",
      "Emergency room": "Sala de emergencias",
      "$4,000 allowance every 36 months": "Asignación de $4,000 cada 36 meses",
      "$10, limit 30 visits per year (combined with acupunture)":
        "$10, límite de 30 visitas por año (combinado con acupuntura)",
      "$10, limit 30 visits per year (combined with chiropractic care)":
        "$10, límite de 30 visitas por año (combinado con atención quiropráctica)",
      "Up to $150 per quarter": "Hasta $150 por trimestre",
      "$75, $0 diagnostic mammography": "$75, $0 mamografía diagnóstica",
      "$13 monthly premium for Dental HMO plan":
        "Prima mensual de $13 para el plan Dental HMO",
      "$1000 allowance every 36 months": "Subsidio de $1000 cada 36 meses",
      "$125/day for days 1 through 5. $0/day for days 6 and beyond":
        "$125/día para los días 1 al 5. $0/día para los días 6 y posteriores",
      "$3500 allowance every 36 months": "Subsidio de $3500 cada 36 meses",
      "$10, limit 30 visits per year (combined with accupuncture)":
        "$10, límite de 30 visitas por año (combinado con acupuntura)",
      "$13 for Dental HMO plan": "$13 para el plan HMO dental",
      "$225/day for days 1-7. $0/day for days 8 +":
        "$225/día para los días 1 a 7. $0/día para los días 8 y superiores",
      "$0 for Dental HMO plan": "$0 para el plan HMO dental",
      "$4,800 allowance every 36 months": "Subsidio de $4,800 cada 36 meses",
      "Up to $170 per quarter": "Hasta $170 por trimestre",
      "15% of the cost, $0 for diagnostic mammography":
        "15% del costo, $0 por mamografía diagnóstica",
      "$150/day for days 1-8. $0/day for days 9+":
        "$150/día para los días 1 a 8.$0/día para los días 9 y posteriores",
      "Monthly  dental plan premium": "Prima mensual del plan dental",
      "$40 for Dental PPO": "$40 por PPO dental",
      "15% of the cost, $0 diagnostic mammography":
        "15% del costo, $0 mamografía diagnóstica",
      "$3,800 allowance every 36 months": "Subsidio de $3,800 cada 36 meses",
      "$75, $0 for diagnostic mammography":
        "$75, $0 por mamografía diagnóstica",
      "Non-Preferred/ Speciality": "No preferido / Especialidad",
      "Preferred Generic/ Generic": "Genérico preferido / Genérico",
      "$40 monthly premium for Dental PPO plan":
        "Prima mensual de $40 para el plan PPO dental",
      "$50/day for days 1 through 6. $0/day for days 7 and beyond":
        "$50/día para los días 1 al 6. $0/día para los días 7 y posteriores",
      "Preferred Brand/ Non-Preferred": "Marca preferida/No preferida",
      "Speciality/ Select Care": "Atención especializada/seleccionada",
    },
  },
  COMMON_TEXT: {
    select: "seleccionar",
    INFORMATION: "INFORMACIÓN DE IDENTIFICACIÓN",
    MEDICARECARD: "TARJETA MEDICARE",
    OTHERS: "OTRAS",
  },
  ATTESTATIONS: {
    "I am new to Medicare.": "Soy nueva en Medicare.",
    "I am enrolled in a Medicare Advantage plan and want to make a change during the Medicare Advantage Open Enrollment Period (OEP), January 1 through March 31":
      "Estoy inscrito en un plan Medicare Advantage y quiero hacer un cambio durante el Período de inscripción abierta (OEP) de Medicare Advantage, del 1 de enero al 31 de marzo.",
    "I recently moved outside of the service area for my current plan or I recently moved and this plan is a new option for me.":
      "Recientemente me mudé fuera del área de servicio de mi plan actual o me mudé recientemente y este plan es una nueva opción para mí.",
    "I recently was released from incarceration.":
      "Hace poco salí de la cárcel.",
    "I recently returned to the United States after living permanently outside of the U.S.":
      "Recientemente regresé a los Estados Unidos después de vivir permanentemente fuera de los EE. UU.",
    "I recently obtained lawful presence status in the United States.":
      "Recientemente obtuve estatus de presencia legal en los Estados Unidos.",
    "I recently had a change in my Medicaid (newly got Medicaid, had a change in level of Medicaid assistance, or lost Medicaid":
      "Recientemente tuve un cambio en mi Medicaid (obtuve Medicaid recientemente, tuve un cambio en el nivel de asistencia de Medicaid o perdí Medicaid).",
    "I recently had a change in my Extra Help paying for Medicare prescription drug coverage (newly got Extra Help, had a change in the level of Extra Help":
      "Recientemente tuve un cambio en mi Ayuda Adicional para pagar la cobertura de medicamentos recetados de Medicare (recibí Ayuda Adicional recientemente, tuve un cambio en el nivel de Ayuda Adicional",
    "I have Medicare and get full medicaid benefits. I want to join or switch to a plan that coordinates coverage between my Medicare and Medicaid managed care plans (called an integrated Dual Eligible Special Needs Plan (D-SNP))":"Tengo Medicare y recibo todos los beneficios de Medicaid. Quiero inscribirme o cambiarme a un plan que coordine la cobertura entre mis planes de atención administrada de Medicare y Medicaid (llamado Plan Integrado de Necesidades Especiales para Personas con Doble Elegibilidad [D-SNP]).",
      "I have both Medicare and Medicaid (or my state helps pay for my Medicare premiums) or I get Extra Help paying for my Medicare prescription drug coverage, but I haven't had a change.":
      "Tengo Medicare y Medicaid (o mi estado me ayuda a pagar mis primas de Medicare) o recibo Ayuda Adicional para pagar mi cobertura de medicamentos recetados de Medicare, pero no he tenido ningún cambio.",
    "I am moving into, live in , or recently moved out of a Long-Term Care Facility (for example, a nursing home or long term care facility).":
      "Me estoy mudando, vivo o me mudé recientemente de un centro de atención a largo plazo (por ejemplo, un hogar de ancianos o un centro de atención a largo plazo).",
    "I recently left a PACE program": "Recientemente dejé un programa PACE",
    "I recently involuntarily lost my creditable prescription drug coverage (coverage as good as Medicare's).":
      "Recientemente perdí involuntariamente mi cobertura acreditable de medicamentos recetados (cobertura tan buena como la de Medicare).",
    "I am leaving employer or union coverage.":
      "Estoy dejando la cobertura del empleador o sindicato.",
    "I belong to a pharmacy assistance program provided by my state.":
      "Pertenezco a un programa de asistencia farmacéutica proporcionado por mi estado.",
    "My plan is ending its contract with Medicare or Medicare is ending its contact with my plan.":
      "Mi plan finaliza su contrato con Medicare o Medicare finaliza su contacto con mi plan.",
    "I was enrolled in a plan by Medicare (or my state) and I want to choose a different plan.":
      "Me inscribí en un plan de Medicare (o de mi estado) y quiero elegir un plan diferente.",
    "I was enrolled in a Special Needs Plan (SNP) but I have lost the special needs qualification required to be in that plan.":
      "Estaba inscrito en un Plan de Necesidades Especiales (SNP), pero perdí la calificación de necesidades especiales requerida para estar en ese plan.",
    "I was affected by an emergency or major disaster (as declared by the Federal Emergency Management Agency (FEMA) or by a Federal, state or local government entity. One of the other statements here applied to me, but I was unable to make my enrollment request because of the disaster.":
      "Fui afectado por una emergencia o desastre mayor (según lo declarado por la Agencia Federal para el Manejo de Emergencias (FEMA) o por una entidad del gobierno federal, estatal o local. Una de las otras declaraciones aquí se aplicó a mí, pero no pude realizar mi inscripción. solicitud debido al desastre.",
    "I am a former employee or spouse/domestic partner/dependent of a former employee of Sharp HealthCare and I am not actively employed by Sharp HealthCare.":
      "Soy un ex empleado o cónyuge/pareja de hecho/dependiente de un ex empleado de Sharp HealthCare y no soy empleado activo de Sharp HealthCare.",
    "I am a retiree or spouse/domestic partner/dependent of a retiree of the City of San Diego enrolling during open enrollment .":
      "Soy un jubilado o cónyuge/pareja de hecho/dependiente de un jubilado de la ciudad de San Diego que se inscribe durante la inscripción abierta.",
    "I am enrolled in a Medicare Advantage plan and want to make a change during the Medicare Advantage Annual Enrollment Period (AEP), October 15 through December 7.":
    "Estoy inscrito en un plan Medicare Advantage y quiero hacer un cambio durante el Período de inscripción anual (AEP) de Medicare Advantage, del 15 de octubre al 7 de diciembre.",
    "I am enrolled in a Medicare Advantage plan and want to make a change during the Medicare Advantage Open Enrollment Period (MA OEP (Jan 1 - March 31)).":
    "Estoy inscrito en un plan Medicare Advantage y quiero hacer un cambio durante el Período de inscripción abierta de Medicare Advantage (MA OEP (1 de enero - 31 de marzo)).",
    // "I am moving into, live in , or recently moved out of a Long-Term Care Facility (for example, a nursing home or long term care facility).":
    // "Me estoy mudando, vivo o me mudé recientemente de un centro de atención a largo plazo (por ejemplo, un hogar de ancianos o un centro de atención a largo plazo).",
    "I have an open enrollment period because I am deemed to have an institutional level of care (OEPI).":
    "Tengo un período de inscripción abierto porque se considera que tengo un nivel de atención institucional (OEPI).",
    "Other":"Otro", 
    SUBQUESTION: {
      "I moved on (insert date)*": "Me mudé (insertar fecha)*",
      "I was released on (insert date)*": "Me liberaron el (insertar fecha)*",
      "I returned to the U.S. on (insert date)*":
        "Regresé a los EE. UU. el (insertar fecha)*",
      "I got this status on (insert date)*":
        "Obtuve este estado el (insertar fecha)*",
      "on (insert date)*": "el (insertar fecha)*",
      "I moved/will move into/out of the facility on (insert date)*":
        "Me mudé/me mudaré a/de la instalación el (insertar fecha)*",
      "I left PACE program on (insert date)*":
        "Abandoné el programa PACE el (insertar fecha)*",
      "I lost my drug coverage on (insert date)*":
        "Perdí mi cobertura de medicamentos el (insertar fecha)*",
      "I am leaving on (insert date)*": "Me voy el (insertar fecha)*",
      "My enrollment in that plan started on (insert date)*":
        "Mi inscripción en ese plan comenzó el (insertar fecha)*",
    },
  },
  FOOTERPLANTYPE: {
    en: {
      INDIVIDUAL: {
        2024: "H5386_2024 Online Individual Enrollment Form V2",
        2025: "H5386_2025 INDV Enrollment Form",
      },
      RETIREE: {
        2024: "H5386_EGWP SHC ONLINE ENROLLMENT FORM_M V2",
        2025: "H5386_2025 SDPEBA ENROLLMENT FORM_M",
      },
      GROUP: {
        2024: "H5386_EGWP SHC ONLINE ENROLLMENT FORM_M V2",
        2025: "H5386_2025 EGWP SHC ENROLLMENT FORM_M",
      },
    },
    es: {
      INDIVIDUAL: {
        2024: "H5386_2024 Formulario de inscripción individual en línea V2",
        2025: "H5386_2025 Formulario de inscripción INDV",
      },
      RETIREE: {
        2024: "H5386_EGWP FORMULARIO DE INSCRIPCIÓN EN LÍNEA SHC_M V2",
        2025: "H5386_2025 FORMULARIO DE INSCRIPCIÓN SDPEBA_M",
      },
      GROUP: {
        2024: "H5386_EGWP FORMULARIO DE INSCRIPCIÓN EN LÍNEA SHC_M V2",
        2025: "H5386_2025 FORMULARIO DE INSCRIPCIÓN EGWP SHC_M",
      },
    },
    TRANSANY: {
      en: {
        SACITY: "Select a County",
      },
      es: {
        SACITY: "Seleccione un condado",
      },
    },
  },
  TRANSANY: {
    en: {
      SACITY: "Select a County",
    },
    es: {
      SACITY: "Seleccione un condado",
    },
  },
};

/*
 @FieldLael is used to customize labels, text based on the customer need( switch case)
 @loginText is used to modify the login texts like continue as guest based on customer need (switch case)
 @ilsFormats is used for ILS customer's accessible formats
 */
export const FieldLabel = (fieldName, customerId) => {
  // const {customerId}=useSelector((state)=>state.login)
  let Label;
  switch (fieldName) {
    case "newfooter": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="app.newfooter" />;
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label = <Text id="nebraska.newfooter" />;
          break;
        }
        default: {
          Label = <Text id="app.newfooter" />;
          break;
        }
      }
      break;
    }
    case "birthDate": {
      // Label =
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          // customerId === id ? (
          Label = <Text id="verda.BirthDate" />;
          // ) : (
          break;
        }
        default: {
          Label = <Text id="app.BirthDate" />;
          break;
        }
      }
      break;
    }
    case "confirmationHeader": {
      // Label =
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = "Verda Enrollment Form";
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label =
            "Blue Cross and Blue Shield of Nebraska Medicare Advantage Enrollment Form";
          break;
        }
        case ILS_CONSTS.ID: {
          Label = <Text id="ils.confirmationHeader" />;
          break;
        }
        default: {
          Label = <Text id="header.confirmationHeader" />;
          break;
        }
      }
      break;
    }
    case "drugCoverage": {
      // Label =
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="verda.drugCoverage" />;
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label = <Text id="nebraska.step1.drugCoverage" />;
          break;
        }
        case ILS_CONSTS.ID: {
          Label = <Text id="ils.step1.drugCoverage" />;
          break;
        }
        default: {
          Label = <Text id="app.drugCoverage" />;
          break;
        }
      }
      break;
    }
    case "accessibleNote": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = (
            <>
              <Text id="verda.step3.Para1" />
              <a href="tel:1-877-933-6767 "> 1-877-933-6767 </a>
              <Text id="verda.step3.Para2" />
            </>
          );
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label = (
            <>
              <Text id="nebraska.step3.contact.para1" />
              <a href="tel:888-488-9850 "> 888-488-9850 </a>
              <Text id="nebraska.step3.contact.para2" />
            </>
          );
          break;
        }
        case ILS_CONSTS.ID: {
          Label = (
            <>
              <Text id="ils.step3.contact.para1" />
              <a href="tel:1-833-322-7526 ">
                {" "}
                1-833-FC2-PLAN (1-833-322-7526){" "}
              </a>
              <Text id="ils.step3.contact.para2" />
            </>
          );
          break;
        }
        default: {
          Label = (
            <>
              <Text id="step2.Para1" />
              <a href="tel:1-855-562-8853"> 1-855-562-8853 </a>
              <Text id="step2.Para2" />
            </>
          );
          break;
        }
      }
      break;
    }
    case "payingPremium": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = (
            <>
              <h4>
                <Text id="verda.step3.premium.Para1" />
              </h4>

              <p>
                <Text id="verda.step3.premium.Para2" />
                <strong>
                  <Text id="verda.step3.premium.Para3" />
                  <Text id="verda.step3.premium.Para4" />
                </strong>
              </p>
              <p>
                <Text id="verda.step3.premium.Para5" />
                <strong>
                  <Text id="verda.step3.premium.Para6" />
                </strong>
              </p>
            </>
          );
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label = (
            <>
              <h4>
                <Text id="verda.step3.premium.Para1" />
              </h4>

              <p>
                <Text id="nebraska.step3.premium.para1" />
                <strong>
                  <Text id="nebraska.step3.premium.para2" />
                </strong>
                <Text id="nebraska.step3.premium.para3" />
              </p>
              <p>
                <Text id="nebraska.step3.premium.para4" />
              </p>
              <p>
                <Text id="nebraska.step3.premium.para5" />
                <strong>
                  <Text id="nebraska.step3.premium.para6" />
                </strong>
              </p>
              <p>
                <Text id="nebraska.step3.premium.para7" />
              </p>
              <p>
                <Text id="nebraska.step3.premium.para8" />
              </p>
            </>
          );
          break;
        }
        case ILS_CONSTS.ID:{
          Label=(
            <>
            {/* <h4>
            <Text id="step2.Para3" />
            </h4> */}

            <p>
              <Text id="ils.step3.premium.para1" />
            </p>
            <p className="mt-3">
            <strong>
                <Text id="ils.step3.premium.para2" />
              </strong>
              <Text id="ils.step3.premium.para3" />
            </p>
          </>
          )
          break;
        }
        default: {
          Label = (
            <>
              <h4>
                <Text id="step2.Para3" />
              </h4>
              <p>
                <Text id="step2.Para4" />.
                <strong>
                  <Text id="step2.Para5" />.
                </strong>
              </p>
              <p>
                <strong>
                  <Text id="step2.Para6" />.
                </strong>
                <Text id="step2.Para6" />.
              </p>
            </>
          );
          break;
        }
      }
      break;
    }
    case "readAndSign": {
      switch (customerId) {
        case NEBRASKA_CONSTS.ID: {
          Label = (
            <>
              <ul>
                <li>
                  <Text id="nebraska.step5.readAndSign.p1" />
                </li>
                <li>
                  <Text id="nebraska.step5.readAndSign.p2" />
                </li>
                <li>
                  <Text id="nebraska.step5.readAndSign.p3" />
                </li>
                <li>
                  <Text id="nebraska.step5.readAndSign.p4" />
                </li>
                <li>
                  <Text id="nebraska.step5.readAndSign.p5" />
                </li>
                <li>
                  <Text id="nebraska.step5.readAndSign.p6" />
                  <br />
                  <Text id="nebraska.step5.readAndSign.p6Sub1" />
                  <br />
                  <Text id="nebraska.step5.readAndSign.p6Sub2" />
                </li>
              </ul>
            </>
          );
          break;
        }
        case ILS_CONSTS.ID: {
          Label = (
            <>
              <ul>
                <li>
                  <Text id="ils.step5.readAndSign.p1" />
                </li>
                <li>
                  <Text id="ils.step5.readAndSign.p2" />
                </li>
                <li>
                  <Text id="ils.step5.readAndSign.p7" />
                </li>
                <li>
                  <Text id="ils.step5.readAndSign.p3" />
                </li>
                <li>
                  <Text id="ils.step5.readAndSign.p4" />
                </li>
                <li>
                  <Text id="ils.step5.readAndSign.p5" />
                </li>
                <li>
                  <Text id="ils.step5.readAndSign.p6" />
                  <br />
                  <Text id="ils.step5.readAndSign.p6Sub1" />
                  <br />
                  <Text id="ils.step5.readAndSign.p6Sub2" />
                </li>
              </ul>
            </>
          );
          break;
        }
        default: {
          Label = (
            <>
              <ul>
                <li>
                  <Text id="app.imp1" />.
                </li>
                <li>
                  <Text id="app.imp2" />.
                </li>
                <li>
                  <Text id="app.imp3" />.
                </li>
                <li>
                  <Text id="app.imp4" />.
                </li>
                <li>
                  <Text id="app.imp5" />.
                </li>

                <li>
                  <Text id="app.imp6" />: <br />
                  {/* <Text id="app.imp6Sub1" />
                              <br />
                              <Text id="app.imp6Sub2" /> */}
                </li>
                <li>
                  <Text id="app.imp7" />:{" "}
                </li>
                <Text id="app.imp8" />
                <br />
                <Text id="app.imp9" />
              </ul>
            </>
          );
          break;
        }
      }
      break;
    }
    case "month": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="verda.step3.month" />;
          break;
        }
        case ILS_CONSTS.ID: {
          Label=(
          <>
          <span><strong><Text id="ils.step3.month"/></strong><Text id="ils.step3.month1"/></span>
          <div className="row float-right">
          <p className="col-md-12 m-0">
            <Text id="ils.step3.monthAddr1"/>
          </p>
          <p className="col-md-12 m-0">
            <Text id="ils.step3.monthAddr2"/>
          </p>
          <p className="col-md-12 m-0">
            <Text id="ils.step3.monthAddr3"/>
          </p>
          <p className="col-md-12 m-0">
            <Text id="ils.step3.monthAddr4"/>
          </p>
          </div>
          </>
          )
          break;
        }
        default: {
          Label = <Text id="app.month" />;
          break;
        }
      }
      break;
    }
    case "autodeduc": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="verda.step3.autodeduc" />;
          break;
        }
        case ILS_CONSTS.ID: {
          Label= <strong><Text id="ils.step3.autodeduc"/></strong>
          break;
        }
        default: {
          Label = <Text id="app.autodeduc" />;
          break;
        }
      }
      break;
    }
    case "RRB": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="verda.step3.RRB" />;
          break;
        }
        default: {
          Label = <Text id="app.RRB" />;
          break;
        }
      }
      break;
    }
    case "Apara": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="verda.step1.APara" />;
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label = <Text id="nebraska.step1.APara" />;
          break;
        }
        case ILS_CONSTS.ID: {
          Label = <Text id="ils.step1.APara" />;
          break;
        }
        default: {
          Label = <Text id="app.APara" />;
          break;
        }
      }
      break;
    }
    case "online1": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="verda.online1" />;
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label = <Text id="nebraska.online1" />;
          break;
        }
        default: {
          Label = <Text id="app.online1" />;
          break;
        }
      }
      break;
    }
    case "soaFooter": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="verda.soa.footer0" />;
          break;
        }
        case ILS_CONSTS.ID: {
          Label = <Text id="ils.soa.footer0" />;
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label = null;
          break;
        }
        default: {
          Label = (
            <>
              <Text id="soa.footer0" />
              <Text id="soa.footer1" />
              <Text id="soa.footer2" />
              <Text id="soa.footer3" />
              <Text id="soa.footer4" />
              <Text id="soa.footer5" />
              <Text id="soa.footer6" />
              <Text id="soa.footer7" />
              <Text id="soa.footer8" />
              <Text id="soa.footer9" />
            </>
          );
          break;
        }
      }
      break;
    }
    case "step2Para": {
      switch (customerId) {
        case VERDA_CONSTS.ID: {
          Label = <Text id="verda.step2.Para4" />;
          break;
        }
        case NEBRASKA_CONSTS.ID: {
          Label = <Text id="nebraska.step2.p1" />;
          break;
        }
        case ILS_CONSTS.ID: {
          Label = <Text id="ils.step2.p1" />;
          break;
        }
        default: {
          Label = <Text id="step3.Para4" />;
          break;
        }
      }
      break;
    }
    case "prospactSOAadvantage": {
      switch (customerId) {
        case NEBRASKA_CONSTS.ID: {
          Label = (
            <>
              <p>
                <strong>
                  Stand-Alone Medicare Prescription Drug Plans (Part D)
                </strong>{" "}
                - Medicare Prescription Drug Plan (PDP): A stand-alone drug plan
                that adds prescription drug coverage to Original Medicare, some
                Medicare Cost Plans, some Medicare Private-Fee-for Service plans
                and Medicare Medical Savings Account Plans.
              </p>
              <p>
                <strong>Medicare Advantage Plans (Part C)</strong> - A Medicare
                Advantage Plan that provides all Original Medicare Part A and
                Part B health coverage and sometimes covers Part D prescription
                drug coverage.
              </p>
              <p>
                Preferred Provider Organization (PPO): Require you to use
                doctors and hospitals in the plan's provider network in order to
                get the most out of your benefits. Referrals are not needed to
                see a doctor, specialist or out-of-network provider; however,
                you will likely have to pay more out of pocket.
              </p>
              <p>
                Health Maintenance Organization (HMO): HMO plans have a network
                of doctors and hospitals. Many HMO plans are now open access,
                where you do not have a primary care physician requirement and
                may not require a referral to see a specialist. In most HMOs,
                you can only get care from doctors or hospitals that are in the
                network (except in emergencies).
              </p>
              <p>
                <strong>Dental/Vision Products</strong> - Health Insurance plans
                offering additional benefits4 for consumers who are looking to
                cover needs for dental or other ancillary products. These plans
                are not affiliated or connected to Medicare.
              </p>
              <p>
                <strong>Medicare Supplement (Medigap) Products</strong> - Health
                Insurance plans offering additional benefits4 for consumers who
                are looking to cover needs for dental or other ancillary
                products. These plans are not affiliated or connected to
                Medicare.
              </p>
              <p>
                Health insurance plans offering a supplemental policy to fill
                “gaps” in Original Medicare coverage. A Medigap policy typically
                pays some or all of the deductible and coinsurance amounts
                applicable to Medicare-covered services and sometimes covers
                items and services that are not covered by Medicare, such as
                care outside of the country. These plans are not affiliated or
                connected to Medicare.
              </p>
              <p>
                Agents are required to submit a Scope of Appointment form with
                each Medicare Advantage Plan or Medicare Prescription Drug
                enrollment application. Scope of Appointment documentation is
                subject to CMS record retention requirements.
              </p>
              <p>
                Out-of-network/non-contracted providers are under no obligation
                to treat Blue Cross and Blue Shield of Nebraska Medicare
                Advantage members, except in emergency situations. Please call
                our customer service number or see your Evidence of Coverage for
                more information, including the cost sharing that applies to
                out-of-network services.
              </p>
            </>
          );
          break;
        }
        default: {
          Label = (
            <>
              <h4>
                <Text id="ils.soa.Advantage" />
              </h4>

              <p>
                <strong>
                  <Text id="ils.soa.ppo" />
                </strong>
                <Text id="ils.soa.medicare" />
              </p>

              <p>
                <strong>
                  <Text id="ils.soa.snp" />
                </strong>
                <Text id="ils.soa.medicareadv" />
              </p>

              <p>
                <strong>(D-SNP)</strong>
                <Text id="ils.soa.dsnp" />
              </p>

              <p>
                <Text id="ils.soa.advcomplies" />
              </p>

              <p>
                <Text id="ils.soa.advrenewal" />
              </p>
            </>
          );
          break;
        }
      }
      break;
    }
    case "emailOptionIndicator":{
      switch (customerId) {
        case ILS_CONSTS.ID:{
          Label=<Text id="ils.step3.emailOptionText"/>
          break;
        }
          
        default:{
          Label=<Text id="step2.EmailOption" />
          break;
        }
      }
      break;
    }
    case "withDrawl":{
      switch (customerId) {
        case NEBRASKA_CONSTS.ID:{
          Label=<Text id="premium.option1" />
          break;
        }
        case ILS_CONSTS.ID:{
          Label=<strong><Text id="ils.step3.option1" /></strong>
          break;
        }
        default:{
          Label=<Text id="premium.option1" />;
          break;
        }
      }
      break;
    }
    default: {
      Label = "";
      break;
    }
  }
  return Label;
};
export const loginText = (loginType, customerId) => {
  let Label;
  switch (loginType) {
    case "beneficiary": {
      Label =
        customerId === VERDA_CONSTS.ID ? (
          "Login as Beneficiary"
        ) : (
          <Text id="user.loginas1" />
        );
      break;
    }
    case "agent": {
      Label = <Text id="user.loginas2" />;
      break;
    }
    default: {
      Label = "";
      break;
    }
  }
  return Label;
};
export const ilsFormats = (langs) => {
  let accFormat = [
    { id: "Sp", label: langs === "es" ? "español" : "SPANISH", value: "SPA" },
    { id: "Cr", label: langs === "es" ? "CRIOLLO" : "CREOLE", value: "HAT" },
    { id: "Ot", label: langs === "es" ? "otro" : "OTHER", value: "OTH" },
  ];
  return accFormat;
};
